import React from "react";
import { EXPERIENCES_INFO_OPTION } from "../../constants/updateVendorConstants";
import UpdateVendorProfile from "../../container/UpdateVendorProfiles/UpdateVendorProfiles";
import { PromptProvider } from "components/Modal/PromptProvider";

const UpdateExperiences = () => (
  <PromptProvider>
    <UpdateVendorProfile bodyContent={EXPERIENCES_INFO_OPTION} />
  </PromptProvider>
);

export default UpdateExperiences;